import { useEffect, useState } from 'react';
import { apiFetch } from '../auth/apiClient';

// Only the count is returned; no reminder narratives are loaded into the shell.
export default function useReminderAttentionCount(enabled, identityKey, view) {
  const [result, setResult] = useState(null);
  useEffect(() => {
    setResult(null);
    if (!enabled || !view) return undefined;
    let disposed = false;
    let controller;
    const refresh = async () => {
      controller?.abort();
      const request = new AbortController();
      controller = request;
      try {
        const response = await apiFetch(`/api/me/reminders/attention-count?${new URLSearchParams({ view })}`, { signal: request.signal });
        if (!response.ok) throw new Error('Reminder count unavailable');
        const data = await response.json();
        if (!Number.isSafeInteger(data.count) || data.count < 0) throw new Error('Invalid reminder count');
        if (!disposed && !request.signal.aborted) setResult({ identityKey, view, count: data.count });
      } catch (_) {
        if (!disposed && !request.signal.aborted) setResult(null);
      }
    };
    const refreshVisible = () => { if (document.visibilityState !== 'hidden') refresh(); };
    refresh();
    window.addEventListener('case-reminders-refresh', refresh);
    window.addEventListener('focus', refreshVisible);
    document.addEventListener('visibilitychange', refreshVisible);
    const timer = window.setInterval(refreshVisible, 60000);
    return () => {
      disposed = true;
      controller?.abort();
      window.clearInterval(timer);
      window.removeEventListener('case-reminders-refresh', refresh);
      window.removeEventListener('focus', refreshVisible);
      document.removeEventListener('visibilitychange', refreshVisible);
    };
  }, [enabled, identityKey, view]);
  return enabled && result?.identityKey === identityKey && result?.view === view ? result?.count ?? null : null;
}
